package dev.wyns.ventrova.ui.theme

import androidx.compose.ui.graphics.Color
import dev.wyns.ventrova.data.model.FryOilStatus
import dev.wyns.ventrova.data.model.PlaceCategory
import dev.wyns.ventrova.data.model.VeganLevel
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.category_bakery
import dev.wyns.ventrova.resources.category_cafe
import dev.wyns.ventrova.resources.category_chip_shop
import dev.wyns.ventrova.resources.category_dessert
import dev.wyns.ventrova.resources.category_fast_food
import dev.wyns.ventrova.resources.category_food_truck
import dev.wyns.ventrova.resources.category_restaurant
import dev.wyns.ventrova.resources.category_shop
import dev.wyns.ventrova.resources.fry_oil_animal_description
import dev.wyns.ventrova.resources.fry_oil_animal_label
import dev.wyns.ventrova.resources.fry_oil_animal_short
import dev.wyns.ventrova.resources.fry_oil_plant_description
import dev.wyns.ventrova.resources.fry_oil_plant_label
import dev.wyns.ventrova.resources.fry_oil_plant_short
import dev.wyns.ventrova.resources.fry_oil_unknown_description
import dev.wyns.ventrova.resources.fry_oil_unknown_label
import dev.wyns.ventrova.resources.fry_oil_unknown_short
import dev.wyns.ventrova.resources.ic_bakery_dining
import dev.wyns.ventrova.resources.ic_bakery_dining_filled
import dev.wyns.ventrova.resources.ic_block
import dev.wyns.ventrova.resources.ic_fastfood
import dev.wyns.ventrova.resources.ic_fastfood_filled
import dev.wyns.ventrova.resources.ic_help_filled
import dev.wyns.ventrova.resources.ic_icecream
import dev.wyns.ventrova.resources.ic_icecream_filled
import dev.wyns.ventrova.resources.ic_local_cafe
import dev.wyns.ventrova.resources.ic_local_cafe_filled
import dev.wyns.ventrova.resources.ic_local_shipping
import dev.wyns.ventrova.resources.ic_local_shipping_filled
import dev.wyns.ventrova.resources.ic_lunch_dining
import dev.wyns.ventrova.resources.ic_lunch_dining_filled
import dev.wyns.ventrova.resources.ic_restaurant
import dev.wyns.ventrova.resources.ic_restaurant_filled
import dev.wyns.ventrova.resources.ic_storefront
import dev.wyns.ventrova.resources.ic_storefront_filled
import dev.wyns.ventrova.resources.ic_water_drop_filled
import dev.wyns.ventrova.resources.level_options_description
import dev.wyns.ventrova.resources.level_options_label
import dev.wyns.ventrova.resources.level_options_short
import dev.wyns.ventrova.resources.level_options_summary
import dev.wyns.ventrova.resources.level_vegan_description
import dev.wyns.ventrova.resources.level_vegan_label
import dev.wyns.ventrova.resources.level_vegan_short
import dev.wyns.ventrova.resources.level_vegan_summary
import dev.wyns.ventrova.resources.level_vegetarian_description
import dev.wyns.ventrova.resources.level_vegetarian_label
import dev.wyns.ventrova.resources.level_vegetarian_short
import dev.wyns.ventrova.resources.level_vegetarian_summary
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource

val VeganLevel.palette: LevelPalette
    get() = when (this) {
        VeganLevel.Vegan -> LevelPalettes.Vegan
        VeganLevel.Vegetarian -> LevelPalettes.Vegetarian
        VeganLevel.VeganOptions -> LevelPalettes.VeganOptions
    }

/** E.g. "100% vegan". */
val VeganLevel.label: StringResource
    get() = when (this) {
        VeganLevel.Vegan -> Res.string.level_vegan_label
        VeganLevel.Vegetarian -> Res.string.level_vegetarian_label
        VeganLevel.VeganOptions -> Res.string.level_options_label
    }

/** E.g. "Veggie", used in chips and list rows. */
val VeganLevel.shortLabel: StringResource
    get() = when (this) {
        VeganLevel.Vegan -> Res.string.level_vegan_short
        VeganLevel.Vegetarian -> Res.string.level_vegetarian_short
        VeganLevel.VeganOptions -> Res.string.level_options_short
    }

val VeganLevel.description: StringResource
    get() = when (this) {
        VeganLevel.Vegan -> Res.string.level_vegan_description
        VeganLevel.Vegetarian -> Res.string.level_vegetarian_description
        VeganLevel.VeganOptions -> Res.string.level_options_description
    }

/** Lower-case summary used next to the label in the onboarding legend. */
val VeganLevel.summary: StringResource
    get() = when (this) {
        VeganLevel.Vegan -> Res.string.level_vegan_summary
        VeganLevel.Vegetarian -> Res.string.level_vegetarian_summary
        VeganLevel.VeganOptions -> Res.string.level_options_summary
    }

val PlaceCategory.label: StringResource
    get() = when (this) {
        PlaceCategory.Restaurant -> Res.string.category_restaurant
        PlaceCategory.FastFood -> Res.string.category_fast_food
        PlaceCategory.ChipShop -> Res.string.category_chip_shop
        PlaceCategory.Cafe -> Res.string.category_cafe
        PlaceCategory.Bakery -> Res.string.category_bakery
        PlaceCategory.Dessert -> Res.string.category_dessert
        PlaceCategory.FoodTruck -> Res.string.category_food_truck
        PlaceCategory.Shop -> Res.string.category_shop
    }

/** Outlined icon, used in list thumbnails and chips. */
val PlaceCategory.icon: DrawableResource
    get() = when (this) {
        PlaceCategory.Restaurant -> Res.drawable.ic_restaurant
        PlaceCategory.FastFood -> Res.drawable.ic_lunch_dining
        PlaceCategory.ChipShop -> Res.drawable.ic_fastfood
        PlaceCategory.Cafe -> Res.drawable.ic_local_cafe
        PlaceCategory.Bakery -> Res.drawable.ic_bakery_dining
        PlaceCategory.Dessert -> Res.drawable.ic_icecream
        PlaceCategory.FoodTruck -> Res.drawable.ic_local_shipping
        PlaceCategory.Shop -> Res.drawable.ic_storefront
    }

/** Filled icon, used on map markers. */
val PlaceCategory.filledIcon: DrawableResource
    get() = when (this) {
        PlaceCategory.Restaurant -> Res.drawable.ic_restaurant_filled
        PlaceCategory.FastFood -> Res.drawable.ic_lunch_dining_filled
        PlaceCategory.ChipShop -> Res.drawable.ic_fastfood_filled
        PlaceCategory.Cafe -> Res.drawable.ic_local_cafe_filled
        PlaceCategory.Bakery -> Res.drawable.ic_bakery_dining_filled
        PlaceCategory.Dessert -> Res.drawable.ic_icecream_filled
        PlaceCategory.FoodTruck -> Res.drawable.ic_local_shipping_filled
        PlaceCategory.Shop -> Res.drawable.ic_storefront_filled
    }

/** E.g. "Plant-based frying oil", the title of the fry oil block on the detail page. */
val FryOilStatus.label: StringResource
    get() = when (this) {
        FryOilStatus.Plant -> Res.string.fry_oil_plant_label
        FryOilStatus.Animal -> Res.string.fry_oil_animal_label
        FryOilStatus.Unknown -> Res.string.fry_oil_unknown_label
    }

/** E.g. "Plant oil", used in list rows and the preview card. */
val FryOilStatus.shortLabel: StringResource
    get() = when (this) {
        FryOilStatus.Plant -> Res.string.fry_oil_plant_short
        FryOilStatus.Animal -> Res.string.fry_oil_animal_short
        FryOilStatus.Unknown -> Res.string.fry_oil_unknown_short
    }

val FryOilStatus.description: StringResource
    get() = when (this) {
        FryOilStatus.Plant -> Res.string.fry_oil_plant_description
        FryOilStatus.Animal -> Res.string.fry_oil_animal_description
        FryOilStatus.Unknown -> Res.string.fry_oil_unknown_description
    }

/** Filled icon. */
val FryOilStatus.icon: DrawableResource
    get() = when (this) {
        FryOilStatus.Plant -> Res.drawable.ic_water_drop_filled
        FryOilStatus.Animal -> Res.drawable.ic_block
        FryOilStatus.Unknown -> Res.drawable.ic_help_filled
    }

/** Background of the fry oil block. */
val FryOilStatus.soft: Color
    get() = when (this) {
        FryOilStatus.Plant -> LevelPalettes.Vegan.soft
        FryOilStatus.Animal -> VentrovaColors.AnimalFatSoft
        FryOilStatus.Unknown -> VentrovaColors.Sand
    }

/** Text and icon color, on [soft] as well as on the page background. */
val FryOilStatus.ink: Color
    get() = when (this) {
        FryOilStatus.Plant -> LevelPalettes.Vegan.ink
        FryOilStatus.Animal -> VentrovaColors.AnimalFatInk
        FryOilStatus.Unknown -> VentrovaColors.Secondary
    }
